"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonAssessmentSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const assessment_template_serializer_1 = require("../../authoring/serializers/assessment-template.serializer");
const date_helper_1 = require("../../helpers/date.helper");
class CommonAssessmentSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(assessmentTemplateSerializer = new assessment_template_serializer_1.AssessmentTemplateSerializer()) {
        super();
        this.assessmentTemplateSerializer = assessmentTemplateSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            districtId: data.districtId,
            schoolId: data.schoolId,
            ownerId: data.ownerId,
            enrollmentPeriodId: data.enrollmentPeriodId,
            startDate: (0, date_helper_1.toLocalDate)(data.startDate),
            totalAssigned: data.totalAssigned,
            totalCompleted: data.totalCompleted,
            assessmentTemplate: data.assessmentTemplate
                ? this.assessmentTemplateSerializer.serializeOne(data.assessmentTemplate)
                : null,
        };
    }
}
exports.CommonAssessmentSerializer = CommonAssessmentSerializer;
//# sourceMappingURL=common-assessment.serializer.js.map